<template>
        <div ref="responseBox" class="k-panel">
            <div class="k-panel__body">

                <div v-if="reaction !== null" class="k-reaction">

                    <a @click="cancelReaction" class="k-reaction__remove" href="javascript:;" title="Zrušit reakci">
                        <svg role="img" width="15" height="15" class="k-btn__icon k-btn__icon--rotate"><use fill="currentColor" xlink:href="/images/spritesheet.svg#add"></use></svg>
                    </a>

                    <div class="k-reaction__author">
                        {{ reaction.user.name }} napsal(a):
                    </div>

                    <div class="k-reaction__text">
                        {{ reaction.content }}
                    </div>

                </div>

                <form @submit.prevent="sendForm" class="k-form">

                    <div class="k-form__group">
                        <label class="k-form__label">Odpověď</label>
                        <textarea ref="responseTextarea" v-model="form.content" class="k-form__textarea" placeholder="Zadejte text odpovědi"></textarea>
                        <field-error v-if="form_errors.content" >{{ form_errors.content[0] }}</field-error>
                    </div>

                    <button type="submit" class="k-btn k-btn--primary">
                        Odeslat odpověď
                    </button>
                </form>

            </div>
        </div>
</template>

<script>
    import FormBase from '../FormBase.vue';

    export default {
        extends: FormBase,

        data: function () {
            return {
                form: {
                    content: '',
                    reaction_id: ''
                },
                reaction: null
            }
        },

        methods: {
            /**
             * React on response
             *
             * @param response
             * @return void
             */
            reactOnResponse: function(response) {
                // scroll to comment box
                if (this.$refs.responseBox) {
                    this.$scrollTo(this.$refs.responseBox, 1000, {offset: -140});
                }
                this.reaction = response;
                this.form.reaction_id = response.id;
                this.$refs.responseTextarea.focus();
            },

            /**
             * Cancel reaction
             *
             * @return void
             */
            cancelReaction: function() {
                this.reaction = null;
                this.form.reaction_id = '';
            },

            /**
             * Send form
             *
             * @returns {Promise<void>}
             */
            sendForm: async function() {
                let result = await this.sendData();
                if (result !== undefined) {
                    if (result.success === true) {
                        this.$emit('responseAdded', result.data.response_id);
                        this.form.content = '';
                        this.cancelReaction();
                    }
                    // flash message
                    if (result.message.length) {
                        flash(result.message, result.success ? 'success' : 'danger');
                    }
                }
            }
        }
    }
</script>
